import { gql } from 'graphql-request';

export const getSettings = gql`
  query GetSettings($userId: Int!) {
    getSettings(userId: $userId) {
      id
      userId
      traditional
      audioDownload
      showRead
      showPinyin
      charSize
      pinyinSize
      charSpaceVal
      startDate
      endDate
      speed
      volume
      charColors
      pinyinColors
      globalDash
      lightFirstTone
      lightSecondTone
      lightThirdTone
      lightFourthTone
      lightFifthTone
      darkFirstTone
      darkSecondTone
      darkThirdTone
      darkFourthTone
      darkFifthTone
      wordSelection
      limitSelection
      skillSelected
      sentenceSelection
      memLimitSelection
      showOutline
      showCharacter
      showHintAfterMiss
      fontFamily
      frontAudio
      frontDefinition
      frontPinyin
      frontWord
      backAudio
      backDefinition
      backPinyin
      backWord
      darkMode
      dictCollapse
      sentenceCollapse
      rulesCollapse
      user {
        id
        username
      }
      cats
      skill {
        id
        level
      }
    }
  }
`;

export const createSettings = gql`
  mutation CreateSettings($input: SettingsInput!) {
    createSettings(input: $input) {
      id
      userId
      traditional
      audioDownload
      showRead
      showPinyin
      charSize
      pinyinSize
      charSpaceVal
      startDate
      endDate
      speed
      volume
      charColors
      pinyinColors
      globalDash
      lightFirstTone
      lightSecondTone
      lightThirdTone
      lightFourthTone
      lightFifthTone
      darkFirstTone
      darkSecondTone
      darkThirdTone
      darkFourthTone
      darkFifthTone
      wordSelection
      limitSelection
      skillSelected
      sentenceSelection
      memLimitSelection
      showOutline
      showCharacter
      showHintAfterMiss
      fontFamily
      frontAudio
      frontDefinition
      frontPinyin
      frontWord
      backAudio
      backDefinition
      backPinyin
      backWord
      darkMode
      dictCollapse
      sentenceCollapse
      rulesCollapse
    }
  }
`;

export const updateSettings = gql`
  mutation UpdateSettings($userId: Int!, $input: SettingsInput!) {
    updateSettings(userId: $userId, input: $input) {
      id
      userId
      traditional
      audioDownload
      showRead
      showPinyin
      charSize
      pinyinSize
      charSpaceVal
      startDate
      endDate
      speed
      volume
      charColors
      pinyinColors
      globalDash
      lightFirstTone
      lightSecondTone
      lightThirdTone
      lightFourthTone
      lightFifthTone
      darkFirstTone
      darkSecondTone
      darkThirdTone
      darkFourthTone
      darkFifthTone
      wordSelection
      limitSelection
      skillSelected
      sentenceSelection
      memLimitSelection
      showOutline
      showCharacter
      showHintAfterMiss
      fontFamily
      frontAudio
      frontDefinition
      frontPinyin
      frontWord
      backAudio
      backDefinition
      backPinyin
      backWord
      darkMode
      dictCollapse
      sentenceCollapse
      rulesCollapse
    }
  }
`;

export const deleteSettings = gql`
  mutation DeleteSettings($userId: Int!) {
    deleteSettings(userId: $userId)
  }
`;

export const deleteSettingsSkill = gql`
  mutation DeleteSettingsSkill($userId: Int!) {
    deleteSettingsSkill(userId: $userId)
  }
`;

export const createOrUpdateSettings = gql`
  mutation CreateOrUpdateSettings($userId: Int!, $input: SettingsInput!) {
    createOrUpdateSettings(userId: $userId, input: $input) {
      id
      userId
      traditional
      audioDownload
      showRead
      showPinyin
      charSize
      pinyinSize
      charSpaceVal
      startDate
      endDate
      speed
      volume
      charColors
      pinyinColors
      globalDash
      lightFirstTone
      lightSecondTone
      lightThirdTone
      lightFourthTone
      lightFifthTone
      darkFirstTone
      darkSecondTone
      darkThirdTone
      darkFourthTone
      darkFifthTone
      wordSelection
      limitSelection
      skillSelected
      sentenceSelection
      memLimitSelection
      showOutline
      showCharacter
      showHintAfterMiss
      fontFamily
      frontAudio
      frontDefinition
      frontPinyin
      frontWord
      backAudio
      backDefinition
      backPinyin
      backWord
      darkMode
      dictCollapse
      sentenceCollapse
      rulesCollapse
    }
  }
`;
